import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService } from 'ng-jhipster';

import { Enrollment } from './enrollment.model';
import { EnrollmentService } from './enrollment.service';
import { SubscriptionType, SubscriptionTypeService } from '../subscription-type';
import { ITEMS_PER_PAGE, Principal, FUZZY_SEARCH_DISTANCE } from '../../shared';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-enrollment',
    templateUrl: './enrollment.component.html'
})
export class EnrollmentComponent implements OnInit, OnDestroy {

    currentAccount: any;
    enrollments: Enrollment[];
    subscriptionTypes: SubscriptionType[];
    error: any;
    success: any;
    eventSubscriber: Subscription;
    currentSearchByStudentName: string;
    currentSearchBySubscriptionType: { id: number, name: string};
    currentSearchByDateFrom: NgbDateStruct;
    currentSearchByDateTo: NgbDateStruct;

    formattedQuery: string;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private enrollmentService: EnrollmentService,
        private subscriptionTypeService: SubscriptionTypeService,
        private parseLinks: ParseLinks,
        private alertService: AlertService,
        private principal: Principal,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private eventManager: EventManager
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data['pagingParams'].page;
            this.previousPage = data['pagingParams'].page;
            this.reverse = data['pagingParams'].ascending;
            this.predicate = data['pagingParams'].predicate;
        });

        this.formattedQuery = activatedRoute.snapshot.params['formattedSearch'] ? activatedRoute.snapshot.params['formattedSearch'] : '';
        if (this.formattedQuery) {
            this.currentSearchBySubscriptionType = activatedRoute.snapshot.params['subscriptionType'];
            this.currentSearchByStudentName = activatedRoute.snapshot.params['studentLabel'] ?
            activatedRoute.snapshot.params['studentLabel'] : '';
            this.currentSearchByDateFrom = {
                year: parseInt(activatedRoute.snapshot.params['yearFrom'], 10),
                month:  parseInt(activatedRoute.snapshot.params['monthFrom'], 10),
                day:  parseInt(activatedRoute.snapshot.params['dayFrom'], 10)
            };
            this.currentSearchByDateTo = {
                year: parseInt(activatedRoute.snapshot.params['yearTo'], 10),
                month:  parseInt(activatedRoute.snapshot.params['monthTo'], 10),
                day:  parseInt(activatedRoute.snapshot.params['dayTo'], 10)
            };
        }

        this.jhiLanguageService.setLocations(['enrollment', 'payment', 'paymentType', 'paymentItem', 'subscriptionType']);
    }

    ngOnInit() {
        this.loadAll();
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInEnrollments();
        this.activatedRoute.params.subscribe((params) => {
            this.loadAll();
        });
        this.principal
        .hasAnyAuthority(['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN', 'ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' ])
        .then((isAllowed: boolean) => {
            // Load all the types of lessons to show in search filter
            if (isAllowed) {
                this.subscriptionTypeService.query()
                .subscribe(
                    (res: HttpResponse<SubscriptionType[]>) => {
                        this.subscriptionTypes = res.body;
                    },
                    (res: HttpErrorResponse) => {
                        this.onError(res);
                    }
                );
            }
        });
    }

    loadAll() {
        if (this.formattedQuery) {
            this.enrollmentService.search({
                page: this.page - 1,
                query: this.formattedQuery,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(
                (res: HttpResponse<Enrollment[]>) => this.onSuccess(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res)
                );
            return;
        }
        this.enrollmentService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(
            (res: HttpResponse<Enrollment[]>) => this.onSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
            );
    }
    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }
    transition() {
        let params = {
            formattedSearch: this.formattedQuery,
            page: this.page,
            size: this.itemsPerPage,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
        };

        if (this.currentSearchByStudentName) {
            params['studentLabel'] = this.currentSearchByStudentName;
        }
        this.router.navigate(['/enrollment'], {
            queryParams: params
        });
        this.loadAll();
    }

    clear() {
        this.page = 0;
        this.currentSearchByStudentName = '';
        this.currentSearchBySubscriptionType = null;
        this.currentSearchByDateFrom = null;
        this.currentSearchByDateTo = null;
        this.formattedQuery = '';
        this.router.navigate(['/enrollment', {
            page: this.page,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
        }]);
        this.loadAll();
    }
    search() {
        this.page = 0;
        this.formattedQuery = this.getQuery();
        if (!this.formattedQuery) {
            return this.clear();
        }
        let params = {
            formattedSearch: this.formattedQuery,
            page: this.page,
            sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
        };

        if (this.currentSearchByStudentName) {
            params['studentLabel'] = this.currentSearchByStudentName;
        }

        this.router.navigate(['/enrollment', params ]);
    }

    getQuery(): string {
        let operators = [];

        if (this.currentSearchBySubscriptionType) {
            operators.push('subscriptionType.id:' + this.currentSearchBySubscriptionType.id);
        }

        if (this.currentSearchByDateFrom) {
            operators.push(this.getDateRangeQueryValidSince(this.currentSearchByDateFrom));
        }

        if (this.currentSearchByDateTo) {
            operators.push(this.getDateRangeQueryValidUntil(this.currentSearchByDateTo));
        }

        if (this.currentSearchByStudentName) {
            let formattedStudentName: string = this.currentSearchByStudentName.split(/[ ]+/)
                .reduce((acumQuery, token) => {
                    let fuzzyToken =  token !== '' ? token + '~' + FUZZY_SEARCH_DISTANCE : '';
                    return acumQuery + ' ' + fuzzyToken;
            }, '');
            operators.push('(student.user.firstName:' + formattedStudentName +
            ' OR ' + 'student.user.lastName:' + formattedStudentName + ')');
        }

        return operators.reduce((query, operator, i) => {
            query = query + operator + ((i < operators.length - 1) ? ' AND ' : '');
            return query;
        }, '');
    }

    private getDateRangeQueryValidSince(fromDate: NgbDateStruct) {
        let fromMonth: number = fromDate.month;
        let fromDay: number = fromDate.day;

        let fromDateTerm: String = fromDate.year + '-'
            + (fromMonth < 10 ? '0' + fromMonth : fromMonth)
            + '-' + (fromDay < 10 ? '0' + fromDay : fromDay);
        return 'validSince:[' + fromDateTerm + ' TO *]';
    }

    private getDateRangeQueryValidUntil( toDate: NgbDateStruct) {
        let realToDate = new Date(toDate.year, toDate.month - 1, toDate.day);
        realToDate.setDate(realToDate.getDate());
        let toDay = realToDate.getDate();
        let toMonth = realToDate.getMonth() + 1 ;
        let toDateTerm: String = realToDate.getFullYear() + '-'
            + (toMonth < 10 ? '0' + toMonth : toMonth )
            + '-'  + (toDay < 10 ? '0' + toDay : toDay);

        return 'validUntil:[* TO ' + toDateTerm + ']';
    }

    dateFromChanged(event) {
        this.currentSearchByDateTo = null;
    }

    isSearchActive() {
        return this.currentSearchByDateFrom || this.currentSearchByDateTo ||
        this.currentSearchByStudentName  || this.currentSearchBySubscriptionType ;
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: Enrollment) {
        return item.id;
    }

    registerChangeInEnrollments() {
        this.eventSubscriber = this.eventManager.subscribe('enrollmentListModification', (response) => this.loadAll());
    }

    sort() {
        let result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        return result;
    }

    private onSuccess(data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.enrollments = data;
    }

    private onError(error) {
        this.alertService.error(error.error, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/enrollment/enrollment.component.ts